import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { Box, Grid, Stack, Typography, Card, IconButton, Slide, Tooltip, Chip, TextField, InputAdornment, CircularProgress } from '@mui/material';
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
// icons
import AngleRightIcon from "common/customIcons/angle_right";
import SearchIcon from "common/customIcons/search";
// utils and helpers
import { formatTimestampToWithoutTime, debounce } from "utilities/common";
import { getRefillProducts, getRefillRegions, handleDownloadRefillBoxPDF, refillLowStockProducts } from "../../../../redux/slices/hyperwolf/inventoryDistribution";
import { showToastMsg } from "components/distributionSetting/distributionManagement/addRegionKit";
// custom components
import CommonLayout from "layouts/DashboardLayout";
import MDButton from 'components/MDButton';
import { TableLoader } from "components/tables/AgGridAccordionChildScrollingTable";
import InfiniteScrollTable from "components/tables/infiniteScrollTable";
import { BrandFilter, SubCategoryFilter, BoxFilter } from "common/filters";
import LowStockProducts from "common/CommonDrawer/hyperwolf/lowStockProducts";

export const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="left" ref={ref} {...props} />;
});

const RefillDetails = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { refillId } = useParams();
  const [searchParams] = useSearchParams()
  const { distributionId, date } = Object.fromEntries(searchParams.entries())

  const [lowStockDrawerOpen, setLowStockDrawerOpen] = useState(false);
  const [regionKits, setRegionKits] = useState([]);
  const [selectedKit, setSelectedKit] = useState({});
  const [customFilters, setCustomFilters] = useState({});
  const [isLoadingRegionKits, setIsLoadingRegionKits] = useState(false);
  const [refreshTable, setRefreshTable] = useState(false);
  const [inputFilters, setInputFilters] = useState({});
  const [isDownloadingBoxPDF, setIsDownloadingBoxPDF] = useState(false);
console.log("regionKits",regionKits);

  const columnDefs = [
    {
      headerName: 'Product Name/SKU',
      field: 'productName',
      key: 'productName',
      suppressMenu: false,
      flex: 2,
      sortable: false,
      setRowId: ({ data }) => data?.productId,
      cellRenderer: (params) => {
        if (!params?.data) return "-";
        const { productName, sku, assets } = params?.data || {}
        const { thumbURL, name } = assets?.[0] || {}

        return <>
          <Box style={{ display: "flex", gap: "10px" }}>
            {thumbURL && <img src={thumbURL} alt={name} width={32} height={32} />}
            <Box>
              <Typography variant='body2' style={{ color: "#2E2E3A", fontWeight: "500", fontSize: "12px" }}>{productName}</Typography>
              {sku && <Typography variant='body2' style={{ color: "#9A9AAF", fontSize: "12px" }}>{sku}</Typography>}
            </Box>
          </Box>
        </>
      }
    },
    {
      headerName: 'Category',
      field: 'category',
      suppressMenu: false,
      sortable: false,
      flex: 2,
      cellRenderer: (params) => {
        if (!params?.data) return "-";
        const { category } = params?.data || {}

        return <Typography variant='body2' style={{ color: "#2E2E3A", fontSize: "12px", padding: "0" }}>{category?.name}</Typography>
      }
    },
    {
      headerName: 'Brand',
      field: 'brand',
      suppressMenu: false,
      sortable: false,
      flex: 2,
      cellRenderer: (params) => {
        if (!params?.data) return "-";
        const { brand } = params?.data || {}

        return <Typography variant='body2' style={{ color: "#2E2E3A", fontSize: "12px", padding: "0" }}>{brand?.name}</Typography>
      }
    },
    // {
    //   headerName: 'Qty Per Driver',
    //   field: 'qtyPerDriver',
    //   suppressMenu: false,
    //   sortable: false,
    //   flex: 1,
    //   cellRenderer: (props) => action === "update" ? <QuantityCellRenderer props={props} setSelectedProducts={setSelectedProducts} /> : props?.data?.qtyPerDriver || 0
    // },
    // {
    //     headerName: 'Retail Price',
    //     field: 'pricePerPiece',
    //     suppressMenu: false,
    //     sortable: false,
    //     flex: 1,
    //     valueGetter: ({ data }) => data?.pricePerPiece ? `$${data?.pricePerPiece?.toLocaleString()}` : "-"
    // },
    {
      headerName: 'Total Qty By Region',
      field: 'totalQtyByRegion',
      suppressMenu: false,
      sortable: false,
      flex: 1,
      valueGetter: ({ data }) => data?.totalQtyByRegion ? `${data?.totalQtyByRegion?.toLocaleString()}` : "-"
    },
    // {
    //     headerName: 'Template Retail Value',
    //     field: 'totalRetailValue',
    //     suppressMenu: false,
    //     sortable: false,
    //     flex: 1,
    //     valueGetter: ({ data }) => data?.totalRetailValue ? `$${data?.totalRetailValue?.toLocaleString()}` : "-"
    // },
    {
      headerName: 'Total Qty Of SKU',
      field: 'totalQtyOfSku',
      suppressMenu: false,
      sortable: false,
      flex: 1,
      valueGetter: ({ data }) => data?.totalQtyOfSku ? `${data?.totalQtyOfSku?.toLocaleString()}` : "-"
    },
    {
      headerName: 'Total Amount Value',
      field: 'totalAmountInSafe',
      suppressMenu: false,
      sortable: false,
      flex: 1,
      valueGetter: ({ data }) => data?.totalAmountInSafe ? `$${data?.totalAmountInSafe?.toLocaleString()}` : "-"
    },
    {
      headerName: 'Driver',
      field: 'drivers',
      suppressMenu: false,
      sortable: false,
      flex: 2,
      cellRenderer: ({ data }) => {
        if (!data) return "-";
        const firstDriverName = data?.drivers?.[0];
        if (data?.drivers?.length <= 1) return firstDriverName;

        return (
          <Tooltip
            title={
              <>
                {data?.drivers?.map(driver => (
                  <Typography key={driver} variant="caption" component="p" fontWeight={500} textAlign="left">
                    {driver}
                  </Typography>
                ))}
              </>
            } arrow>
            <span className='table-row-chip chip-cus' style={{ cursor: "pointer" }}>
              {firstDriverName}
              <Chip
                key={data?._id || ""}
                label={`+${data?.drivers?.length - 1}`}
                style={{ p: 0 }}
              />
            </span>
          </Tooltip>
        );
      },
    },
  ];

  const handleSelectedKit = (region) => {
    setSelectedKit(region);
    setCustomFilters({});
    setRefreshTable(prev => !prev)
  };

  const handleChange = (e) => {
    const { value, name } = e.target;

    setCustomFilters(prev => ({ ...prev, [name]: value }));
    setRefreshTable(prev => !prev)
  };

  const handleClearFilters = () => {
    setCustomFilters({});
    setRefreshTable(prev => !prev);
  };

  const handleRefillRegions = async () => {
    setIsLoadingRegionKits(true);
    try {
      const response = await dispatch(getRefillRegions({ distributionId, refillId })).unwrap();
      const { data } = response || {};
      if (data) {
        setRegionKits(data || []);
        const region = data?.[0] || {};
        if (region?.regionId) {
          setSelectedKit(region);
          setCustomFilters(prev => ({ ...prev, regionId: region?.regionId }))
          setRefreshTable(prev => !prev)
        }
      }
    }
    catch (error) {
      showToastMsg(error, "error")
    } finally {
      setIsLoadingRegionKits(false);
    }
  };

  const handleDebounceSearch = useCallback(debounce((event) => {
    const { name, value } = event.target;

    setCustomFilters(prev => ({ ...prev, [name]: value }));
    setRefreshTable(prev => !prev)
  }, 1000), []);

  useEffect(() => {
    handleRefillRegions();
  }, []);

  const isFilterSelected = useMemo(() => {
    // Return true if any filter in customFilters is selected (truthy)
    return (
      Object.values(customFilters || {}).some(Boolean)
    );
  }, [customFilters]);

  const handleDownloadBoxPDF = async () => {
    if (isDownloadingBoxPDF || !selectedKit.regionId) return;
    setIsDownloadingBoxPDF(true);
    try {
      const response = await dispatch(handleDownloadRefillBoxPDF({ distributionId:refillId, regionId: selectedKit.regionId })).unwrap();
      if (response?.url) {
        // Create a temporary link to download the PDF
        const link = document.createElement('a');
        link.href = response.url;
        link.download = "Refill_kit.pdf";
        link.target = "_blank";
        document.body.appendChild(link);
        link.click();
        setTimeout(() => {
          document.body.removeChild(link);
        }, 100);
      }
    }
    catch (error) {
      showToastMsg(error, "error");
    } finally {
      setIsDownloadingBoxPDF(false);
    }
  };

  return (
    <CommonLayout>
      <Box p={4} className="cus-contents">
        <Stack
          direction={{ xs: "column", sm: "row" }}
          alignItems={{ sm: "center" }}
          justifyContent="space-between"
          gap={2}
          mb={4}
        >
          <Box display="flex" alignItems="center" color="text.main" lineHeight={1}>
            <IconButton onClick={() => navigate(-1)}>
              <AngleRightIcon fontSize="14px" />
            </IconButton>
            <Typography variant="h6" fontWeight="semibold" ml={0.75}>
              Distribution ({date ? formatTimestampToWithoutTime(Number(date)) : ""})
            </Typography>
          </Box>
        </Stack>

        <Grid container spacing={3}>
          {/* Top actions */}
          <Grid item xs={12}>
            <Stack direction='row' gap={1} alignItems='center' justifyContent="space-between" className="res-flex-col">
              <div className="d-flex align-item-top gap-2">
                {/* Low Stock Products */}
                <MDButton
                  variant="contained"
                  sx={{ minWidth: '160px', background: "#2E2E3A !important", color: "#ffffff !important", fontSize: "14px", minHeight: "36px", padding: "7px 20px" }}
                  onClick={() => setLowStockDrawerOpen(true)}
                >
                  Low Stock Products
                </MDButton>
              </div>
              {
                 
                  <MDButton
                    variant="contained"
                    sx={{ minWidth: '150px', background: "#ffffff !important", color: "#2E2E3A !important", fontSize: "14px", minHeight: "36px", border: "1px solid #D0D0DA", padding: "7px 20px" }}
                    className="d-flex align-item-center jc-center gap-1"
                    disabled={isDownloadingBoxPDF ||  !selectedKit.regionId}
                    onClick={handleDownloadBoxPDF}
                  >
                    {
                      isDownloadingBoxPDF ?
                        <CircularProgress size={20} />
                        : <>
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M2 11V12.5C2 12.8978 2.15804 13.2794 2.43934 13.5607C2.72064 13.842 3.10218 14 3.5 14H12.5C12.8978 14 13.2794 13.842 13.5607 13.5607C13.842 13.2794 14 12.8978 14 12.5V11M11 8L8 11M8 11L5 8M8 11V2" stroke="#2E2E3A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                          <span>Get Refill Box PDF</span>
                        </>
                    }
                  </MDButton>
                }
            </Stack>
          </Grid>

          <Grid item xs={12}>
            <div className="distribution-with-sidebar">
              {/* Left side section */}
              <div className="dis-sidebar-left">
                <Card sx={{ p: { xs: 2, md: 3 }, borderRadius: 2.5, boxShadow: "none", height: "100%" }}>
                  {/* Add Region btn */}
                  <Stack direction='row' gap={1} alignItems='center' justifyContent="space-between">
                    <Typography variant="h5" fontWeight="semibold">Region Kits</Typography>
                  </Stack>

                  {/* Regions kits listing */}
                  
                  {/* {
                    isLoadingRegionKits ?
                      <TableLoader />
                      : 
                      <ul>
                        {
                          regionKits?.map((region) => (
                            <li
                              key={region.regionId}
                              className={selectedKit.regionId === region.regionId ? "active" : ""}
                              onClick={() => handleSelectedKit(region)}
                            >
                              <div className="d-flex align-item-center jc-s-btwn gap-1 mb-2">
                                <Typography variant="h6" fontWeight="medium" color="#2E2E3A">{region.name}</Typography>
                              </div>
                              <div className="d-grid grid-columns-two gap-2">
                               
                                <div className="d-flex align-item-top flex-column gap-1">
                                  <Typography color="#656575">Kit Value</Typography>
                                  <span>${region?.wholesaleValue || 0}</span>
                                </div>
                                <div className="d-flex align-item-top flex-column gap-1">
                                  <Typography color="#656575">Refill Qty</Typography>
                                  <span>{region?.refilledQty}</span>
                                </div>
                              </div>
                            </li>
                          ))
                        }
                      </ul>
                  } */}
                  {
                                      isLoadingRegionKits ?
                                        <TableLoader />
                                        : <ul>
                                          {
                                            regionKits?.map((region) => (
                                              <li
                                                key={region.regionId}
                                                className={selectedKit.regionId === region.regionId ? "active" : ""}
                                                onClick={() => handleSelectedKit(region)}
                                              >
                                                <div className="d-flex align-item-center jc-s-btwn gap-1 mb-2">
                                                  <Typography variant="h6" fontWeight="medium" color="#2E2E3A">{region.regionName}</Typography>
                                                 
                                                </div>
                                                <div className="d-grid grid-columns-one gap-2">
                                              
                                                  {
                                                    region?.subRegions?.length > 0 &&
                                                    region?.subRegions?.map(subRegion => (
                                                      <div key="" className="d-grid grid-columns-two gap-2-5" style={{ backgroundColor: "#f7f7f9", padding: "10px", borderRadius: "4px" }}>
                                                        <div className="d-flex align-item-top flex-column gap-1">
                                                          <Typography color="#656575">Sub Region</Typography>
                                                          <span>{subRegion?.subRegionName || "-"}</span>
                                                        </div>
                                                        <div className="d-flex align-item-top flex-column gap-1">
                                                          <Typography color="#656575">Kit Value</Typography>
                                                          <span>${subRegion?.wholesaleValue?.toLocaleString()}</span>
                                                        </div>
                                                        <div className="d-flex align-item-top flex-column gap-1">
                                                          <Typography color="#656575">Unique Products</Typography>
                                                          <span>{subRegion?.totalProducts?.toLocaleString()}</span>
                                                        </div>
                                                        <div className="d-flex align-item-top flex-column gap-1">
                                                          <Typography color="#656575">Total Qty</Typography>
                                                          <span>{subRegion?.totalQtyDistributed?.toLocaleString()}</span>
                                                        </div>
                                                      </div>
                                                    ))
                                                  }
                                                </div>
                                              </li>
                                            ))
                                          }
                                        </ul>
                                    }
                </Card>
              </div>

              <div className="dis-con-right">
                <Card sx={{ p: { xs: 2, md: 3 }, borderRadius: 2.5, boxShadow: "none", height: "100%" }}>

                  {/* Listing Actions */}
                  <Stack direction='row' gap={1} mb={2} alignItems='center' justifyContent="space-between">
                    <Typography variant="h6" fontWeight="semibold" mb={1}>
                      Showing products for {selectedKit.name}
                    </Typography>

                    <Stack direction='row' alignItems='center' justifyContent="end" className='gap-2 right-side-btns'>
                      {/* Search Filter */}
                      <Box className="search-gray">
                        <TextField
                          className="custom-search-field"
                          placeholder="Search"
                          name="search"
                          size='small'
                          value={inputFilters.search || ""}
                          onChange={e => {
                            const { value } = e.target;
                            setInputFilters({ ...inputFilters, search: value })
                            handleDebounceSearch(e);
                          }}
                          InputProps={{
                            startAdornment: <InputAdornment position="start">
                              <IconButton size='small'>
                                <SearchIcon width='18px' height='18px' />
                              </IconButton>
                            </InputAdornment>
                          }}
                          style={{ minWidth: "225px" }}
                        />
                      </Box>
                    </Stack>
                  </Stack>

                  {/* Listing Filters */}
                  <Box className='cus-filter-sec filter-gray-bg' mb={2}>
                    <Grid className='filter-box' container alignItems='center' justifyContent='flex-start' spacing={1.5}>
                      <Grid item xs={12} lg={3} xxxl={2.5}>
                        <BoxFilter
                          value={customFilters?.boxId}
                          handleChange={handleChange}
                          placeholder={"Box Type"}
                          selectAllLabel={"All Boxes"}
                        />
                      </Grid>
                      <Grid item xs={12} lg={3} xxxl={2.5}>
                        <SubCategoryFilter
                          value={customFilters?.categoryId}
                          handleChange={handleChange}
                          placeholder={"Category"}
                          selectAllLabel={"All categories"}
                        />
                      </Grid>
                      <Grid item xs={12} lg={3} xxxl={2.5}>
                        <BrandFilter
                          value={customFilters?.brandId}
                          handleChange={handleChange}
                          placeholder={"Brands"}
                          selectAllLabel={"All"}
                        />
                      </Grid>
                      <Grid item xs={12} lg={3} xxxl={2.5}>
                        <MDButton
                          sx={{ minWidth: "120px", fontWeight: "normal" }}
                          type="button"
                          variant="outlined"
                          color="dark"
                          onClick={handleClearFilters}
                          disabled={!isFilterSelected}
                        >
                          Clear All
                        </MDButton>
                      </Grid>
                    </Grid>
                  </Box>
                  {
                    selectedKit?.regionId &&
                    <InfiniteScrollTable
                      tableName="Box Products"
                      getDataMethod={getRefillProducts}
                      columnDefs={columnDefs}
                      refreshTable={refreshTable}
                      customFilters={{ ...customFilters, regionId: selectedKit?.regionId, distributionId: refillId }}
                    />
                  }
                </Card>
              </div>

            </div>
          </Grid>
        </Grid>

        {/* low stock products */}
        <LowStockProducts
          open={lowStockDrawerOpen}
          TransitionComponent={Transition}
          handleClose={() => setLowStockDrawerOpen(false)}
          getDataMethod={refillLowStockProducts}
          dataFilters={{ refillId }}
        />
      </Box>
    </CommonLayout>
  )
}

export default RefillDetails